module.exports = __webpack_public_path__ + "img/419@2x.909ae414.png";